var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.cPragraphs),function(paragraph,index){return _c('p',{key:index},[_vm._v(_vm._s(paragraph))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }